import React from 'react';
import { PropTypes } from 'prop-types';
import { get } from 'lodash';
import formatDate from 'common/utils/Dates/formatDate';
import BaseTimelineEvent from 'common/Workqueue/BaseTimelineEvent';

const EnrollmentCreateEvent = ({ timelineEvent }) => {
  const additionalData = get(timelineEvent, 'additional_data', {});
  const eventChanges = get(timelineEvent, 'changes', []);
  const employeeName = get(additionalData, 'employee_name', 'System');
  const recordShortId = eventChanges.find((change) => change.field_name === 'short_id').to;
  const date = formatDate(timelineEvent.timestamp);

  const eventDetails = (
    <div className="text-12px text-dark-grey">
      Enrollment Request ID: #{recordShortId}
    </div>
  );

  return (
    <BaseTimelineEvent
      icon="IconSubmit"
      message={`Submitted by ${employeeName}`}
      date={date}
      eventDetails={eventDetails}
      shouldDisplayIconDivider={false}
    />
  );
};

EnrollmentCreateEvent.propTypes = {
  timelineEvent: PropTypes.object.isRequired,
};

export default EnrollmentCreateEvent;
